// extracted by mini-css-extract-plugin
export var headerXL = "SectionLogoRow-module--headerXL--34U-M";
export var headerL = "SectionLogoRow-module--headerL--25wUp";
export var headerM = "SectionLogoRow-module--headerM--IPX6m";
export var headerS = "SectionLogoRow-module--headerS--3cDDx";
export var headerXS = "SectionLogoRow-module--headerXS--1J68R";
export var blogHeaderXL = "SectionLogoRow-module--blogHeaderXL--2ivR6";
export var blogHeaderL = "SectionLogoRow-module--blogHeaderL--13-cU";
export var blogHeaderM = "SectionLogoRow-module--blogHeaderM--3QlmX";
export var blogHeaderS = "SectionLogoRow-module--blogHeaderS--noCow";
export var blogHeaderXS = "SectionLogoRow-module--blogHeaderXS--3gJpI";
export var headerPreamble = "SectionLogoRow-module--headerPreamble--291vK";
export var preHeader = "SectionLogoRow-module--preHeader--3xUos";
export var textNormal = "SectionLogoRow-module--textNormal--3flCV";
export var textSmall = "SectionLogoRow-module--textSmall--1NjI8";
export var textSmallAlternate = "SectionLogoRow-module--textSmallAlternate--3pNlE";
export var legend = "SectionLogoRow-module--legend--3zdOH";
export var caption = "SectionLogoRow-module--caption--tjoQy";
export var gradientBackground = "SectionLogoRow-module--gradientBackground--2Jq-b";
export var ellipsis = "SectionLogoRow-module--ellipsis--2Wpeg";
export var globalContainer = "SectionLogoRow-module--globalContainer--8nMJ1";
export var maxWidth = "SectionLogoRow-module--maxWidth--33BqJ";
export var clipBottom = "SectionLogoRow-module--clipBottom--2WHxx";
export var clipTopBottom = "SectionLogoRow-module--clipTopBottom--3WstD";
export var logoRow = "SectionLogoRow-module--logoRow--2-XHO";
export var logoRowNoTopMargin = "SectionLogoRow-module--logoRowNoTopMargin--W-CiT";
export var companyLogo = "SectionLogoRow-module--companyLogo--mTKTv";
export var logoContainer = "SectionLogoRow-module--logoContainer--3PNBR";
export var ch2 = "SectionLogoRow-module--ch2--rx86N";
export var ch2Container = "SectionLogoRow-module--ch2-container--35tD8";